import React from "react";
import { Box } from "@showitinc/showit-wc";
import BetaLabel from "../../components/beta/BetaLabel";
import styles from "./Toolbar.module.css";

const ToolbarMiddle = () => {
  return <Box className={styles.betaToolbarItem}>
    <BetaLabel />
  </Box>;
};

export default ToolbarMiddle;
